export default "__VITE_ASSET__CnKOqMFN__"